import { Routes } from '@angular/router';

export const accountRoutes: Routes = [
  {
    path: 'payment',
    loadComponent: () =>
      import('./payment-basket/payment-basket.component').then(
        (x) => x.PaymentBasketComponent
      ),
    data: {
      title: 'Payment',
    },
  },
  {
    path: 'history',
    loadComponent: () =>
      import('./history/history.component').then((x) => x.HistoryComponent),
    data: {
      title: 'History',
    },
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./settings/settings.component').then((x) => x.SettingsComponent),
    data: {
      title: 'Settings',
    },
  },
  {
    path: 'cards',
    loadComponent: () =>
      import('./my-cards/my-cards.component').then((x) => x.MyCardsComponent),
    data: {
      title: 'MyCards',
    },
  },
];
